<canvas #outputCanvas></canvas>

<span class="qr-source-host" aria-hidden="true">
  <qrcode
    [qrdata]="qrdata"
    [width]="size"
    [margin]="4"
    colorDark="#000000"
    colorLight="#ffffff"
    elementType="canvas"
    errorCorrectionLevel="Q"
    (qrCodeURL)="onQrReady()">
  </qrcode>
</span>
